// extracted by mini-css-extract-plugin
export default {"containerForm":"styles_containerForm__zSdZG","tipsUsername":"styles_tipsUsername__rzUQp","tipsIcon":"styles_tipsIcon__RnNWR"};